module.exports = __webpack_public_path__ + "assets/img/jtfx54.43de0ce3.jpg";